export const workflowFallback = {
  patient: 'Willow, Gwen Marry',
  mrNumber: '2318634'
};

export const workflowSteps = [
  {
    id: 'issue-created',
    label: 'Issue Created',
    description: 'Office staff created patient issue',
    dateTime: '5/15/2026 at 5:30 PM',
    user: 'Jennifer Lee',
    content: [
      'Category: Medication • Priority: Routine',
      'Assigned to: Dr. Alice William',
      'Note: Patient requesting refill for hypertension medication. Current prescription expires today.'
    ]
  },
  {
    id: 'provider-responded',
    label: 'Provider Responded',
    description: 'Provider reviewed and responded to issue',
    dateTime: '5/16/2026 at 5:30 PM',
    user: 'Dr. Alice William',
    content: [
      'Response: Approved for refill. Same dosage as previous. Can send to pharmacy directly.',
      'Recommendation: Continue Current Plan',
      'Urgency: Routine'
    ]
  },
  {
    id: 'patient-notified',
    label: 'Patient Notified',
    description: 'Staff completed patient notification',
    dateTime: '5/17/2026 at 5:30 PM',
    user: 'Jennifer Lee',
    content: [
      'Communication Method: Patient Portal',
      'Contact Outcome: Reached'
    ]
  }
];